export const featureIcons = [
  { key: 'bed', label: 'bed', icon: '🛏' },
  { key: 'bedroom', label: 'bedroom', icon: '🚪' },
  { key: 'bath', label: 'bath', icon: '🛁' },
  { key: 'wifi', label: 'WiFi', icon: '📶' },
  { key: 'parking', label: 'parking', icon: '🚗' },
  { key: 'pet', label: 'pet-friendly', icon: '🐶' },
  { key: 'air conditioning', label: 'A/C', icon: '❄️' },
  { key: 'kitchen', label: 'kitchen', icon: '🍳' },
  { key: 'microwave', label: 'microwave', icon: '📡' },
  { key: 'dishwasher', label: 'dishwasher', icon: '🍽️' },
  { key: 'oven', label: 'oven', icon: '🔥' },
  { key: 'washing machine', label: 'laundry', icon: '🧺' },
  { key: 'balcony', label: 'balcony', icon: '🌇' },
  { key: 'elevator', label: 'elevator', icon: '🛗' },
  { key: 'swimming pool', label: 'pool', icon: '🏊' },
  { key: 'gym', label: 'gym', icon: '🏋️' },
  { key: 'fire extinguisher', label: 'safety', icon: '🧯' },
];
